import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Cta } from '../common';
import { EXT, openExternal } from '../../config/links';
import { ShieldMark } from '../Logo';

export default function FinalCTA() {
  return (
    <section className="section">
      <div className="container-x">
        <div className="relative panel overflow-hidden reveal" style={{ padding: '84px 32px', textAlign: 'center' }}>
          <div className="absolute inset-0 grid-bg opacity-60" />
          <div className="absolute inset-0 gold-glow-soft" />
          <div className="relative flex flex-col items-center">
            <ShieldMark size={64} className="mb-7" />
            <h2 className="font-display font-bold tracking-tight" style={{ fontSize: 'clamp(30px, 4.6vw, 54px)', lineHeight: 1.08, letterSpacing: '-0.025em', maxWidth: 780 }}>
              <span className="silver-text">The market is moving.</span><br /><span className="gold-text">Your intelligence should move with it.</span>
            </h2>
            <p className="section-sub mx-auto mt-5">Build strategies. Validate ideas. Find opportunities. Execute with control.</p>
            <div className="mt-9 flex flex-col sm:flex-row items-center gap-3">
              <Cta size="lg" href={EXT.SIGNUP} onClick={() => openExternal(EXT.SIGNUP, 'hero_cta_click')}>Start Trading <ArrowRight size={18} /></Cta>
              <Link to="/platform" className="btn-outline inline-flex items-center justify-center gap-2 rounded-xl h-14 px-9 text-[16px] font-semibold">Explore Kalki AI <ArrowRight size={16} /></Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
